import React, { useEffect, useRef } from "react";
import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { FooterModel } from "../Models/FooterModel";
import Utils from "../Utils/Utils";
import ExternalFormsUtils from "../../product/ExternalForms/ExternalFormsUtils";

import "./Footer.css";
declare global {
  interface Window {
    transcend?: any;
  }
}

const Footer: React.FC<{ blok: FooterModel }> = ({ blok }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!blok || !containerRef.current) return;

    const container = containerRef.current as HTMLDivElement;
    const scripts = Utils.getScripts(container, blok.script);
    Utils.loadScripts(scripts, containerRef);

    ExternalFormsUtils.waitForIframeAndApplyStyles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (window.transcend) {
      window.transcend.showConsentManager({ viewState: "CompleteOptions" });
    }
  };

  return (
    <div className="footer-container" {...storyblokEditable(blok)}>
      <div className="row">
        <div className="col-6">
          <div className="row footer-newsletter" ref={containerRef}></div>

          <div className="social-media row">
            {blok.socialMedia?.length > 0
              ? blok.socialMedia.map((butt) => (
                  <StoryblokComponent blok={butt} key={butt._uid} />
                ))
              : null}
          </div>
        </div>
        <div className="col-6 footer-links-container">
          <div className="footer-links">
            {blok.topHyperlinks?.length > 0
              ? blok.topHyperlinks.map((butt) => (
                  <StoryblokComponent blok={butt} key={butt._uid} />
                ))
              : null}
          </div>
        </div>
      </div>
      <div className="row footer-links-mobile-container">
        <div className="col-6">
          <div className="footer-links">
            {blok.topHyperlinks?.length > 0
              ? blok.topHyperlinks.map((butt) => (
                  <StoryblokComponent blok={butt} key={butt._uid} />
                ))
              : null}
          </div>
        </div>
      </div>
      <div className="row border-top">
        <div className="col-12 logo-area">
          <img
            src={Utils.getCacheUrl(blok.copyrightImage.filename)}
            alt=""
            onError={(e) =>
              Utils.handleImageError(e, blok.copyrightImage.filename)
            }
          />{" "}
          <div className="footer-links-bottom">
            {blok.bottomHyperlinks?.length > 0
              ? blok.bottomHyperlinks.map((butt) => (
                  <StoryblokComponent blok={butt} key={butt._uid} />
                ))
              : null}
          </div>
          <div> </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 footer-copyright">
          <p>
            {blok.copyright.split("<br>").map((text, index) => (
              <span key={index}>
                {text}
                <br />
              </span>
            ))}
          </p>
          <span id="umg-consent-manager" onClick={handleClick}>
            Cookie Choices
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
